var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid-title"},[_c('h4',[_vm._v(_vm._s(_vm.$t("_SUPPORT.TITLE")))])]),_c('div',{staticClass:"grid-body p-3 border-top-unset"},[_c('div',{attrs:{"id":"connect"}},[_c('div',{staticClass:"content-wrapper d-flex flex-column",domProps:{"innerHTML":_vm._s(_vm.$t('_CONFIGURATION.BE_SUPPORT'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }